import { render, staticRenderFns } from "./Name.vue?vue&type=template&id=a8c09bfc&"
import script from "./Name.vue?vue&type=script&lang=ts&"
export * from "./Name.vue?vue&type=script&lang=ts&"
import style0 from "./Name.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports